import ReactStars from "react-rating-stars-component"
import HalfStar from "@/public/icons/half-star.svg"
import FullStar from "@/public/icons/full-star.svg"
import WhiteStar from "@/public/icons/white-star.svg"
import EmptyStar from "@/public/icons/empty-star.svg"

const ReviewList = props => {
  const { reviewsList } = props
  const getDate = date => {
    const currentDate = new Date()
    const targetDate = new Date(date)
    const timeDifference = currentDate.getTime() - targetDate.getTime()

    const seconds = Math.floor(timeDifference / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)
    const months = Math.floor(days / 30.44) // Approximate
    const years = Math.floor(days / 365.25) // Approximate

    if (years > 0) {
      return `${years} year${years === 1 ? "" : "s"} ago`
    } else if (months > 0) {
      return `${months} month${months === 1 ? "" : "s"} ago`
    } else if (days > 0) {
      return `${days} day${days === 1 ? "" : "s"} ago`
    } else if (hours > 0) {
      return `${hours} hour${hours === 1 ? "" : "s"} ago`
    } else if (minutes > 0) {
      return `${minutes} minute${minutes === 1 ? "" : "s"} ago`
    } else {
      return `${seconds} second${seconds === 1 ? "" : "s"} ago`
    }
  }
  return (
    <div className="review-content-parent">
      {reviewsList?.map((item, i) => (
        <div className="review-content" key={i}>
          <div className="user-name">{item.authorName}</div>
          <div className="title-rating-container">
            <ReactStars
              count={5}
              value={item.rating}
              size={24}
              edit={false}
              isHalf={true}
              emptyIcon={<img src={EmptyStar.src} />}
              halfIcon={<img src={HalfStar.src} />}
              filledIcon={<img src={FullStar.src} />}
            />
            <div className="rating-title">{item.title}</div>
            <div className="rating-star">{getDate(item.createdAt)}</div>
            <div className="rating-description">{item.text}</div>
          </div>
        </div>
      ))}
    </div>
  )
}
export default ReviewList
